import { ArrowSmallRightIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { Link } from 'react-router-dom';
import { FeatureFlag, useFeatureFlag } from 'utils/permissions/feature-flags';

interface Props {
  link: string;
  text: string;
  disabled?: boolean;
}

export const HistoricalDataLink: React.FC<Props> = (props) => {
  const { link, text, disabled } = props;

  const showHistoricalLink = useFeatureFlag(FeatureFlag.AccessHistoricalPerDiem);
  if (!showHistoricalLink) {
    return null;
  }

  return (
    <Link
      to={link}
      className={`group flex ${
        disabled && 'pointer-events-none'
      } justify-between items-center p-2 px-5 bg-gray-100 hover:bg-gray-200 transition-colors border border-gray-300 rounded-lg rounded-t-none`}
    >
      <div className={`truncate text-sm font-medium text-gray-${disabled ? '400' : '700'}`}>
        {text}
      </div>
      {!disabled && (
        <ArrowSmallRightIcon className="h-5 w-5 text-gray-700 group-hover:text-blue-900 transition-colors" />
      )}
    </Link>
  );
};
